import React from 'react';
import { Button } from 'semantic-ui-react';
import './ExternalLinkButton.css';

const ExternalLinkButton = ({ text, link, floated, size }) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <Button
        className="ExternalLinkButton btn-animated"
        floated={floated || 'left'}
        size={size || 'small'}
      >
        {text}
      </Button>
    </a>
  );
};

export default ExternalLinkButton;



// WEBPACK FOOTER //
// ./src/components/UtilityComponents/ExternalLinkButton/index.js